import type { CommsSentSmsDelivery } from '@ucp/web/lib';

/** The four AC 31a labels, in display order (PRO-3060). Text, never colour alone (NF-10). */
export function smsDeliveryCounts(
  delivery: CommsSentSmsDelivery,
): ReadonlyArray<{ readonly label: string; readonly count: number }> {
  return [
    { label: 'delivered', count: delivery.delivered },
    { label: 'delivery failed', count: delivery.deliveryFailed },
    { label: 'awaiting confirmation', count: delivery.awaitingConfirmation },
    { label: 'confirmation unavailable', count: delivery.confirmationUnavailable },
  ];
}

export function smsDeliverySentence(delivery: CommsSentSmsDelivery): string {
  return `SMS: ${smsDeliveryCounts(delivery)
    .map(({ label, count }) => `${count} ${label}`)
    .join(' · ')}`;
}

export const SMS_DELIVERY_NOTE = 'Sending does not prove the message was received.';
